<template>
    <div class="message-body">
        {{ message.body.text }}
    </div>
</template>

<script>
export default {
    name: "DefaultMessageTemplate",

    props: {
        message: {
            required: true,
            type: Object,
        },
    },
}
</script>
